define("ROOM4.CCAProductGallery.CCAProductGallery.SchemaPublisher.View", [
  "Backbone",
  "ROOM4.CCAProductGallery.CCAProductGallery.SchemaHelper",
  "room4_ccaproductgallery_schema_publisher.tpl",
], function (Backbone, SchemaHelper, template) {
  "use strict";

  return Backbone.View.extend({
    template: template,

    initialize: function initialize(options) {
      this.schemaPublisherDomId = options.schemaPublisherDomId;
    },

    getContext: function getContext() {
      var organization = SchemaHelper.getOrganizationSchemaContext();

      return {
        schemaPublisherDomId: this.schemaPublisherDomId,
        schemaPublisherId: organization.id,
        schemaPublisherName: organization.name,
        schemaPublisherUrl: organization.url,
        schemaPublisherLogoUrl: organization.logoUrl,
        schemaPublisherTelephone: organization.telephone,
        schemaPublisherEmail: organization.email,
        schemaPublisherSameAs: organization.sameAs,
        hasSchemaPublisherUrl: organization.hasUrl,
        hasSchemaPublisherLogo: organization.hasLogo,
        hasSchemaPublisherTelephone: organization.hasTelephone,
        hasSchemaPublisherEmail: organization.hasEmail,
        hasSchemaPublisherSameAs: organization.hasSameAs,
      };
    },
  });
});
